import { render } from "./FavoriteView.vue?vue&type=template&id=667cc1ba&scoped=true"
import script from "./FavoriteView.vue?vue&type=script&lang=js"
export * from "./FavoriteView.vue?vue&type=script&lang=js"

import "./FavoriteView.vue?vue&type=style&index=0&id=667cc1ba&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667cc1ba"]])

export default __exports__